import React from 'react';
import {
  Grid,
  Box,
  Typography,
  Alert,
  Chip
} from '@mui/material';
import { Icon } from '@iconify/react';
import LocationCard from './LocationCard';
import { Loader } from 'src/components/Loader';

const LocationList = ({ 
  locations, 
  selectedLocationIds = [],
  onLocationSelect,
  onView, 
  onEdit, 
  onDelete,
  isLoading = false,
  emptyMessage = "No locations found"
}) => {
  if (isLoading) {
    return <Loader variant='skeleton' skeletonVariant='card' skeletonCount={6} />
  }

  if (!locations || locations.data.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Icon 
          icon="eva:map-pin-outline" 
          style={{ fontSize: '64px', color: '#ccc', marginBottom: '16px' }}
        />
        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
          {emptyMessage}
        </Typography>
        <Alert severity="info" sx={{ maxWidth: 400, mx: 'auto' }}>
          <Typography variant="body2">
            No charging locations have been added yet. Locations will appear here once they are configured.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      {/* Results Summary */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Showing {locations.data.length} location{locations.data.length !== 1 ? 's' : ''}
        </Typography>
        <Chip 
          label={`${locations.data.length} total`} 
          size="small" 
          color="primary" 
          variant="outlined"
        />
      </Box>

      {/* Location Grid */}
      <Grid container spacing={3}>
        {locations?.data && locations.data.map((location) => (
          <Grid item xs={12} sm={6} md={4} key={location.id}>
            <LocationCard
              location={location}
              selected={selectedLocationIds.includes(location.id)}
              onSelect={onLocationSelect}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LocationList;
